import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RetriveFormComponent } from './retrive-form.component';

const routes: Routes = [
  {
    path: '',
    component: RetriveFormComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RetriveFormRoutingModule {}
